import callApi from "helpers/callApi";

export function getClientNotificationCenterCounters(appId) {
  return callApi("/notify/client_notification_center/counters", "GET", {
    app_id: appId,
  });
}

export function getClientNotificationCenterReporting({
  appId,
  offset = 0,
  limit = 20,
}) {
  return callApi("/notify/client_notification_center/reporting", "GET", {
    app_id: appId,
    offset,
    limit,
  });
}

export function getClientNotificationCenterReportingCalendar({
  appId,
  offset = 0,
  limit = 20,
}) {
  return callApi(
    "/notify/client_notification_center/reporting_calendar",
    "GET",
    {
      app_id: appId,
      offset,
      limit,
    }
  );
}

export function getClientNotificationCenterMessages({
  appId,
  offset = 0,
  limit = 20,
}) {
  return callApi("/notify/client_notification_center/messages", "GET", {
    app_id: appId,
    offset,
    limit,
  });
}

export function getClientNotificationCenterRegistrationTracker({
  appId,
  offset = 0,
  limit = 20,
}) {
  return callApi(
    "/notify/client_notification_center/registration_tracker",
    "GET",
    {
      app_id: appId,
      offset,
      limit,
    }
  );
}

export function getClientNotificationCenterThresholds({
  appId,
  offset = 0,
  limit = 20,
}) {
  return callApi("/notify/client_notification_center/thresholds", "GET", {
    app_id: appId,
    offset,
    limit,
  });
}

export function getClientNotificationCenterProduct({
  appId,
  offset = 0,
  limit = 20,
}) {
  return callApi("/notify/client_notification_center/product", "GET", {
    app_id: appId,
    offset,
    limit,
  });
}

export function getClientNotificationCenterBilling({
  appId,
  offset = 0,
  limit = 20,
}) {
  return callApi("/notify/client_notification_center/billing", "GET", {
    app_id: appId,
    offset,
    limit,
  });
}

export function getClientNotificationCenterSettings({
  appId,
  offset = 0,
  limit = 20,
}) {
  return callApi("/notify/client_notification_center/settings", "GET", {
    app_id: appId,
    offset,
    limit,
  });
}

export function getClientNotificationCenterInvoices({
  appId,
  offset = 0,
  limit = 20,
}) {
  return callApi("/notify/client_notification_center/invoices", "GET", {
    app_id: appId,
    offset,
    limit,
  });
}

export function getClientNotificationCenterTransactions({
  appId,
  offset = 0,
  limit = 20,
}) {
  return callApi("/notify/client_notification_center/transactions", "GET", {
    app_id: appId,
    offset,
    limit,
  });
}

export function getClientNotificationCenterConsumption({
  appId,
  offset = 0,
  limit = 20,
}) {
  return callApi("/notify/client_notification_center/consumption", "GET", {
    app_id: appId,
    offset,
    limit,
  });
}

/** POST /notify/client_notification_center/{id}/seen — no body; company from session. */
export function markClientNotificationCenterSeen(id) {
  const safeId = encodeURIComponent(String(id ?? "").trim());
  return callApi(
    `/notify/client_notification_center/${safeId}/seen`,
    "POST",
    {},
    { omitBody: true }
  );
}
